import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { CarsCategoryModel } from 'src/models/cars/carsCategory';
import { API_url } from '../api.setup';

const carsCategory = '/carCategorycategories';

const CarCategoryService = {
  getAllCarCategory: async () => {
    try {
      const response = await axios.get(`${API_url}${carsCategory}/getall`);
      return response.data as CarsCategoryModel[];
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up the request:', error.message);
      }
      throw error;
    }
  },

  addCarsCategory: async (dataToUpdate: CarsCategoryModel) => {
    const remodel = {
      name: dataToUpdate.name,
      status: dataToUpdate.status
    };
    try {
      const response = await axios.post(`${API_url}${carsCategory}`, remodel);
      enqueueSnackbar(
        `Car Category " ${dataToUpdate.name} " added Successfully`,
        {
          variant: 'success'
        }
      );
      return response.data as CarsCategoryModel;
    } catch (error) {
      throw error;
    }
  },

  deleteCarsCategory: async (carsCategoryId, data) => {
    try {
      const response = await axios.delete(
        `${API_url}${carsCategory}/delete?id=${carsCategoryId}`
      );
      enqueueSnackbar(`Car Category " ${data.name} " Deleted Successfully`, {
        variant: 'success'
      });
      return response.data as CarsCategoryModel;
    } catch (error) {
      throw error;
    }
  },

  editCarsCategory: async (editedData: CarsCategoryModel) => {
    try {
      const response = await axios.put(
        `${API_url}${carsCategory}/update`,
        editedData
      );
      enqueueSnackbar(
        `Car Category " ${editedData.name} " edited Successfully`,
        {
          variant: 'success'
        }
      );
      return response.data as CarsCategoryModel;
    } catch (error) {
      throw error;
    }
  },

  uploadCarCategoryImage: async (categoryId: number, file: File) => {
    try {
      const formData = new FormData();
      formData.append('file', file); 
      const response = await axios.post(`${API_url}${carsCategory}/uploadImage?categoryId=${categoryId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      enqueueSnackbar(`Image uploaded successfully for cars ID ${categoryId}`, {
        variant: 'success'
      });
      return response.data;
      
    } catch (error) {
      if (error.response) {
        console.error('Response error:', error.response.data);
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Error setting up the request:', error.message);
      }
      throw error;
    }
  },
};

export default CarCategoryService;
